var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-resend.b9259903.png","uri@2x": __webpack_public_path__ + "icon-resend.6c18ec90.png","uri@3x": __webpack_public_path__ + "icon-resend.385c5f4f.png",
    width: 40,
    height: 40
});